<template>
  <div>
    <div v-if="!isRead" class="navigation-tabs">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label class="label-first">Upload File</label>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group flex">
            <b-form-file v-model="uploadFile" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></b-form-file>
            <b-overlay :show="isLoadingUpload" class="d-inline-block" rounded opacity="0.6" spinner-small spinner-variant="primary">
              <b-button @click="UploadFileNow()" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Upload</b-button>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <div class="tables">
<!--      <BaseTable-->
<!--        :fields="fields"-->
<!--        :items="items"-->
<!--        :loading="loading"-->
<!--        :rows="pagination.total"-->
<!--        :perPage="filter.size"-->
<!--        :currentPage="filter.page"-->
<!--        :handle-page-change="handlePageChange"-->
<!--        :hideView="true"-->
<!--        :hideUpdate="true"-->
<!--        :hideDelete="true"-->
<!--        :HideOptions="true"-->
<!--      />-->
      <b-table :current-page="0" :busy="loading" :per-page="filter.size" :fields="fields" :items="items" :responsive="true">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell()="data">
          <div v-if="IsNumberic(data)">
            <p>{{ Currency(data.value) }}</p>
          </div>
          <div v-if="!IsNumberic(data)">
            <p>{{ data.value }}</p>
          </div>
        </template>
      </b-table>
      <div class="mt-2">
        <b-pagination v-model="filter.page" :total-rows="pagination.total" :per-page="filter.size">

        </b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormFile,BTable,BPagination,BOverlay,BSpinner } from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility'
export default {
  name: "UploadPieceTab",
  components: {
    BCard,
    BRow,
    BButton,
    BaseTable,
    BFormFile,
    BTable,
    BPagination,
    BOverlay,
    BSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    isRead: {
      type: Boolean
    }
  },
  data() {
    return {
      fields: [],
      items: [],
      loading: false,
      uploadFile: null,
      isLoadingUpload: false,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetPieceUpload();
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    IsNumberic(data) {
      // window.console.log(data);
      return utility.isNumeric(data.value);
    },
    GetPieceUpload() {
      this.loading = true;
      let router = this.$route;
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        payslipId: router.params.id,
        isUpload: true
      };
      this.fields = [];
      this.items  = [];
      this.$http.get('/payslip/employee-payslip', { params: req })
        .then((result) => {
          window.console.log(result);
          this.fields.push({
            key: 'no',
            label: 'No'
          });
          if (result.data.code === "00") {
            result.data.data.data.header.forEach((items) => {
                this.fields.push({
                  key: items.headerName,
                  label: items.headerName
                });
            });
            let dataBody =  result.data.data.data.body;
            for (let i = 0; i < dataBody.length; i++) {
              let obj = {};
              for (let j = 0; j < dataBody[i].listData.length; j++) {
                 const entries = Object.entries(dataBody[i].listData[j]);
                if (entries[0][0] !== 'id') {
                  Object.assign(obj,{[entries[0][0]]: entries[0][1]})
                }
                if (entries[1][0] !== 'id') {
                  Object.assign(obj,{[entries[1][0]]: entries[1][1]})
                }
              }
              this.items.push(obj);
            }
            this.pagination.total = result.data.data.totalPages;
          }
          this.loading  =  false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loading  =  false;
        });
    },
    Currency(value) {
      return `Rp ${utility.FormatCurrency(value)}`;
    },
    UploadFileNow() {
      window.console.log(this.uploadFile);
      if (this.uploadFile === null) {
        return errorNotification(this, "Oops!", "Tidak Ada File Yang diupload");
      }
      let router = this.$route;
      this.isLoadingUpload = true;
      let formData  =  new FormData();
      formData.append('file', this.uploadFile);
      formData.append('payslipId',router.params.id);
      formData.append('isUpload', true);
      this.$http.put(`/payslip/payslip-upload-amount/${router.params.id}`, formData)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.GetPieceUpload();
          } else {
            errorNotification(this,"Oops!",result.message);
          }
          this.isLoadingUpload = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isLoadingUpload = false;
        });
    }
  },
  mounted() {
    this.GetPieceUpload();
  }
}
</script>
